<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <template v-for="(menuData, index) in $store.getters.menuArr">
                <li v-bind:key="index" :id="menuData.slug" :class="'menuCommon '+menuData.slug">
                    <template v-if="menuData.sub_menu == '' || menuData.sub_menu == null">
                        <template v-if="menuData.url != null && menuData.url != ''">
                            <template v-if="menuData.menu_title.length >= 22">
                                <a :href="menuData.url" target="_blank" v-b-tooltip.hover :title="menuData.menu_title">
                                    <span :class="'spm-nav-menu ' + menuData.icon_url">    
                                    </span>
                                    {{stringTrim(menuData.menu_title,22)}}
                                </a>
                            </template>
                            <template v-else>
                                <a :href="menuData.url" target="_blank">
                                    <span :class="'spm-nav-menu ' + menuData.icon_url">    
                                    </span>
                                    {{menuData.menu_title}}
                                </a>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="menuData.menu_title.length >= 22">
                                <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                    <span :class="'spm-nav-menu ' + menuData.icon_url">
                                    </span>{{stringTrim(menuData.menu_title,22)}}
                                </router-link>
                            </template>
                            <template v-else>
                                <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                    <span :class="'spm-nav-menu ' + menuData.icon_url">
                                    </span>{{menuData.menu_title}}
                                </router-link>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="menuData.url != null && menuData.url != ''">
                            <template v-if="menuData.menu_title.length >= 22">
                                <a v-b-tooltip.hover :title="menuData.menu_title" :href="menuData.url" target="_blank">
                                    <label class="tree-toggle nav-header">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span> {{stringTrim(menuData.menu_title,22)}}
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </label>
                                </a>
                            </template>
                            <template v-else>
                                <a :href="menuData.url" target="_blank">
                                    <label class="tree-toggle nav-header">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span> {{menuData.menu_title}}
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </label>
                                </a>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="menuData.menu_title.length >= 22">
                                <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                    <label class="tree-toggle nav-header">
                                        <span :class="'spm-nav-menu ' + menuData.icon_url">
                                        </span> {{stringTrim(menuData.menu_title,22)}}
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </label>
                                </router-link>
                            </template>
                            <template v-else>
                                <template v-if="( loginUserRoleId === 1 || loginUserRoleId === 2 ) && menuData.menu_title == 'Manager\'s Section'">
                                    <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <label class="tree-toggle nav-header">
                                            <span :class="'spm-nav-menu ' + menuData.icon_url">
                                            </span> {{menuData.menu_title}}
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </label>
                                    </router-link>
                                </template>
                                <template v-else>
                                    <template v-if="menuData.menu_title != 'Manager\'s Section'">
                                        <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                            <label class="tree-toggle nav-header">
                                                <span :class="'spm-nav-menu ' + menuData.icon_url">
                                                </span> {{menuData.menu_title}}
                                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                                            </label>
                                        </router-link>
                                    </template>
                                </template>
                            </template>
                        </template>
                        <ul class="nav nav-list tree">
                            <template v-for="(subMenuData, index1) in menuData.sub_menu">
                                <template v-if="subMenuData.url != null && subMenuData.url != ''">
                                    <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                        <template v-if="subMenuData.menu_title.length >= 30">
                                            <a v-b-tooltip.hover :title="subMenuData.menu_title" :href="subMenuData.url" target="_blank">
                                                {{stringTrim(subMenuData.menu_title,30)}}
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a :href="subMenuData.url" target="_blank">
                                                {{subMenuData.menu_title}}
                                            </a>
                                        </template>
                                    </li>
                                </template>
                                <template v-else>
                                    <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                        <template v-if="subMenuData.menu_title.length >= 30">
                                            <router-link v-b-tooltip.hover :title="subMenuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                {{stringTrim(subMenuData.menu_title,30)}}
                                            </router-link>
                                        </template>
                                        <template v-else>
                                            <router-link v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                {{subMenuData.menu_title}}
                                            </router-link>
                                        </template>
                                    </li>
                                </template>
                            </template>
                        </ul>
                    </template>
                </li>
                <!-- <li>
                    <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-map-marker fa-stack-1x "></i></span> Sales Programs <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                    <ul class="nav nav-list tree">
                        <li>Standard Operating Procedures</li>
                        <li>Marketing Materials</li>
                        <li>Warranty</li>
                        <li>Certification</li>
                        <li>Sales Meetings</li>
                        <li><a href="/colorchart">Color Chart</a></li>
                        <li><a href="#">Buttons</a></li>
                    </ul>
                </li> -->
            </template>
            <li>
                <label class="tree-toggle nav-header">
                    <span class="spm-nav-menu icon-procedures">    
                    </span>
                    Forms <i class="fa fa-angle-down" aria-hidden="true"></i>
                </label>
                <ul class="nav nav-list tree">
                    <!-- <li>
                        <a href="https://app.smartsheet.com/b/form/de5a85437880446fa434fb85b012be80" target="_blank">
                            RO Reversal Request
                        </a>
                    </li>
                    <li>
                        <a href="https://app.smartsheet.com/b/form/c3be6cf5e7844a92b46d1fc25c0530d8" target="_blank">
                            Suspended R/O Review
                        </a>
                    </li> -->
                    <li>
                        <a href="https://app.smartsheet.com/b/form/13f5bdfe6fd64292ade93753a453db79" target="_blank">
                            Technician Time Edit Request
                        </a>
                    </li>
                    <li>
                        <a href="https://app.smartsheet.com/b/form/0ad051a32c614b468a268e08ede5cb8e" target="_blank">
                            Support Staff Time Edit
                        </a>
                    </li>
                    <!-- <li>
                        <a href="https://app.smartsheet.com/b/form/23b275589e2f4a5eb20507ebd45482a3" target="_blank">
                            Sublet Request Form
                        </a>
                    </li> 
                    <li>
                        <a href="https://app.smartsheet.com/b/form/5c4938154bac4d3da6a2c0df305dc166" target="_blank">
                            COps Task request
                        </a>
                    </li>
                    <li>
                        <a href="https://app.smartsheet.com/b/form/dd02ed0e4f5b40cfaca9428e52c75739" target="_blank">
                            Goodwill/Rework Request Form
                        </a>
                    </li>
                    <li>
                        <a href="https://app.smartsheet.com/b/form/4854987c0fc94c859b678c2ad8dcd784" target="_blank">
                            Payroll Enquiry Form
                        </a>
                    </li>
                    <li>
                        <a href="https://app.smartsheet.com/b/form/1d5a2840bf384026ac55abba15fb58fe" target="_blank">
                            Change of shift request
                        </a>
                    </li> -->
                    <!-- <template v-if="loginUserRoleId === 1 || loginUserRoleId === 2">
                        <li id="ROReversalRequest">
                            <router-link v-bind:to="{name: 'ListROReversalRequest'}">
                                RO Reversal Request
                            </router-link>
                        </li>
                        <li id="SuspendedROReview">
                            <router-link v-bind:to="{name: 'ListSuspendedROReview'}">
                                Suspended R/O Review
                            </router-link>
                        </li>
                        <li id="TechTimeForm">
                            <router-link v-bind:to="{name: 'ListTechTime'}">
                                Technician Time Edit Request -->
                                <!-- Tech Time Edit Request -->
                            <!-- </router-link>
                        </li> -->
                        <!-- <li id="TechTimeSpanishForm">
                            <router-link v-bind:to="{name: 'ListSpanishTechTime'}">
                                Tech Time Edit Request (Spanish)
                            </router-link>
                        </li> -->
                        <!-- <li id="SupportStaffForm">
                            <router-link v-bind:to="{name: 'ListSupportStaff'}"> -->
                                <!-- Dayforce Time Edit Request -->
                                <!-- Kronos Time Edit Request -->
                                <!-- Support Staff Time Edit
                            </router-link>
                        </li> -->
                        <!-- <li id="TechicianShiftChangeForm">
                            <router-link v-bind:to="{name: 'ListTechicianShiftChange'}">
                                Technician Shift Change
                            </router-link>
                        </li>
                        <li id="TechnicianTeamDepartmentChangesForm">
                            <router-link v-bind:to="{name: 'ListTechnicianTeamDepartmentChanges'}">
                                Technician Team/Department Change
                            </router-link>
                        </li> -->
                        <!-- <li id="TechnicianUniForm">
                            <router-link v-bind:to="{name: 'ListTechnicianUniform'}">
                                Uniform Request
                            </router-link>
                        </li>
                        <li id="OfficeSuppliesForm">
                            <router-link v-bind:to="{name: 'ListOfficeSupplier'}">
                                Office Supplies Order
                            </router-link>
                        </li>
                        <li id="PPEOrderSupploes">
                            <router-link v-bind:to="{name: 'ListPPEOrderSupplies'}">
                                PPE Order Form
                            </router-link>
                        </li> -->
                    <!-- </template>
                    <template v-else>
                         <li id="ROReversalRequest">
                            <router-link v-bind:to="{name: 'AddUpdateROReversalRequest'}">
                                RO Reversal Request
                            </router-link>
                        </li>
                        <li id="SuspendedROReview">
                            <router-link v-bind:to="{name: 'AddUpdateSuspendedROReview'}">
                                Suspended R/O Review
                            </router-link>
                        </li>
                        <li id="TechTimeForm">
                            <router-link v-bind:to="{name: 'AddUpdateTechTime'}">
                                Technician Time Edit Request -->
                                <!-- Tech Time Edit Request -->
                            <!-- </router-link>
                        </li> -->
                        <!-- <li id="TechTimeSpanishForm">
                            <router-link v-bind:to="{name: 'AddUpdateSpanishTechTime'}">
                                Tech Time Edit Request (Spanish)
                            </router-link>
                        </li> -->
                        <!-- <li id="SupportStaffForm">
                            <router-link v-bind:to="{name: 'AddUpdateSupportStaff'}"> -->
                                <!-- Dayforce Time Edit Request -->
                                <!-- Kronos Time Edit Request -->
                                <!-- Support Staff Time Edit
                            </router-link>
                        </li> -->
                        <!-- <li id="TechicianShiftChangeForm">
                            <router-link v-bind:to="{name: 'AddUpdateTechicianShiftChange'}">
                                Technician Shift Change
                            </router-link>
                        </li>
                        <li id="TechnicianTeamDepartmentChangesForm">
                            <router-link v-bind:to="{name: 'AddUpdateTechnicianTeamDepartmentChanges'}">
                                Technician Team/Department Change
                            </router-link>
                        </li> -->
                        <!-- <li id="TechnicianUniForm">
                            <router-link v-bind:to="{name: 'AddUpdateTechnicianUniform'}">
                                Uniform Request
                            </router-link>
                        </li>
                        <li id="OfficeSuppliesForm">
                            <router-link v-bind:to="{name: 'AddUpdateOfficeSupplier'}">
                                Office Supplies Order
                            </router-link>
                        </li>
                        <li id="PPEOrderSupploes">
                            <router-link v-bind:to="{name: 'AddUpdatePPEOrderSupplies'}">
                                PPE Order Form
                            </router-link>
                        </li> -->
                    <!-- </template>
                    <template>
                        <li id="SubletReversalForm">
                            <router-link v-bind:to="{ name: 'ListSubletReversalForm' }">
                                Sublet Reversal Form
                            </router-link>
                        </li>
                    </template>
                    <template v-if="loginUsername === 'dev@vvgtruck.com.au' || loginUsername === 'ksheehan@vvgtruck.com.au'">
                        <li id="TechicianShiftChangeForm">
                            <router-link v-bind:to="{name: 'ListTechicianShiftChange'}">
                                Technician Shift Change
                            </router-link>
                        </li>
                        <li id="TechnicianTeamDepartmentChangesForm">
                            <router-link v-bind:to="{name: 'ListTechnicianTeamDepartmentChanges'}">
                                Technician Team/Department Change
                            </router-link>
                        </li>
                    </template> -->
                    <!-- <template v-if="permissionsArray.includes('access_vendor_request_form')">
                        <li id="ListVendor">
                            <router-link v-bind:to="{name: 'ListVendor'}">
                                Vendor
                            </router-link>
                        </li>
                    </template> -->
                    <!-- <template v-if="permissionsArray.includes('access_form_email_manager')">
                        <li id="ListFormEmailManager">
                            <router-link v-bind:to="{name: 'ListFormEmailManager'}">
                                Form Email Manager
                            </router-link>
                        </li>
                    </template> -->
                    <!-- <li id="TrainingRequestForm">
                        <router-link v-bind:to="{name: 'ListTrainingRequest'}">
                            Training Request
                        </router-link>
                    </li> -->
                </ul>
            </li>
        </ul>
    </div>
<!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../../http-common.js';
    import EventBus from '.././event-bus';
    var self;

    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: 'Center',
        mixins: [commonMixins],
        data() {
            return {
                menuArr: [],
                loginUserRoleId: 1,
                loginUsername: 9999999,
                permissionsArray: ['access_vendor_request_form', 'access_form_email_manager'],
            }

        },
        beforeMount: function () {

        },
        mounted: function () {
            self = this;
            $("#menu-toggle").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function (e) {
                //console.log("here");
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                // self.loginUserRoleId = userJson['role'].system_id;/
                self.loginUsername = userJson['username'];
                self.$store.dispatch('loadMenu');
            }
        },
        methods: {
        }
    };
    EventBus.$on('reload-menu', function (menuArr) {
        //console.log('Event Called');
        if (typeof (self) != 'undefined') {
            self.$nextTick(() => {
                self.firstLoadMenu();
            });
        }
    });
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            if(permissionArray && permissionArray.length > 0) {
                for (var i = 0; i < permissionArray.length; i++) {
                    self.permissionsArray.push(permissionArray[i].name);
                }
            }
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/partials/Sidebar.vue